import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

const Recent = () => {
    const [movies, setMovies] = useState([]);

    useEffect(() => {
        const fetchMovies = async () => {
            try {
                const response = await fetch('https://api.themoviedb.org/3/trending/all/day?language=en-US', {
                    headers: {
                        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0YWVjN2U4OGY0ZGNhNWUxY2E3M2Q1MGEzYjA2NTc5YSIsInN1YiI6IjY1ZjUzMjAzMGYyZmJkMDE3ZGMxMWFlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.pK4qhRi_GcSo0plShYkihT1aS3NqbhpXpGSQE5QKHEc',
                        'Accept': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                if (data.results) {
                    setMovies(data.results);
                } else {
                    console.error('Data results are undefined');
                }
            } catch (error) {
                console.error('Error fetching movies:', error);
            }
        };

        fetchMovies();
    }, []);

    const slickSettings = {
        dots: true,
        infinite: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className="container" style={{ justifyContent: 'center' }}>
            {/* Bootstrap container class */}
            <br/>
            <br/>
            <div className='screen' style={{ width: '100%', height: '50%' }}>
                {/* Adjusted height of the slider container */}
                <Slider {...slickSettings}>
                    {movies.length > 0 ? (
                        movies.map((movie) => (
                            <div key={movie.id} className='movie__intro' style={{ position: 'relative' }}>
                                <a href={`/movie/${movie.id}`} style={{ display: 'block', width: '100%', height: '100%' }}>
                                    <img
                                        src={`https://image.tmdb.org/t/p/original${movie.backdrop_path}`}
                                        alt={movie.title || movie.name}
                                        className='movie__backdrop'
                                        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                    />
                                    <h3 style={{ position: 'absolute', bottom: 0, left: 0, margin: '10px', color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.5)', padding: '5px' }}>
                                        {movie.title || movie.name}
                                    </h3>
                                </a>
                            </div>
                        ))
                    ) : (
                        <p>No movies found.</p>
                    )}
                </Slider>
            </div>
        </div>
    );
};

export default Recent;
